/* eslint-disable @typescript-eslint/no-explicit-any */

import { YodaColors } from 'yoda-ui/yodaTheme';

const useAdminDashboardParetoChart = () => {
  const tooltipContent = (props: any) => {
    const { active, payload, label } = props;
    if (!active || !payload?.length) return null;

    const valueItem = payload.find((p: any) => p.dataKey === 'count');
    const cumulativeItem = payload.find((p: any) => p.dataKey === 'cumulativePercent');

    return {
      label,
      valueItem,
      cumulativeItem,
    };
  };

  const renderLabel = (props: any) => {
    const { value, x, y, width, height } = props;
    const fillColor = Number(y) >= (Number(y) + Number(height) - 40) ? YodaColors.black : YodaColors.white;

    return {
      value,
      x: Number(x) + Number(width) / 2,
      y: Number(y) + Number(height) - 30,
      width,
      height,
      fillColor,
    };
  };

  return {
    tooltipContent,
    renderLabel,
  };
};

export default useAdminDashboardParetoChart;
